import React, { useEffect, useState } from "react";
import HRNavbar from "../../HR/HRNavbar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/system";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Box from "@mui/material/Box";
import { TextField, Button, TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Footer";
import { API_URL } from "../../Config/api";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputBase, Stack } from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const EmployeeCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  marginRight: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "43px",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  "&:hover": {
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
    borderLeft: "4px solid #A5D6A7",
    borderRight: "4px solid #A5D6A7",
  },
  fontWeight: "200",
});

const LoginEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const accessToken = localStorage.getItem("token");
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);

  const openLogoutDialog = (employeeId) => {
    setSelectedEmployeeId(employeeId);
    setOpenDialog(true);
  };

  const fetchEmployees = async () => {
    try {
      const response = await fetch(
        `${API_URL}/hhc_hcm/forcefully_logout_api/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setEmployees(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [accessToken, API_URL]);

  const handleConfirmLogout = async () => {
    setOpenDialog(false);
    try {
      const response = await fetch(
        `${API_URL}/hhc_hcm/forcefully_logout_api/?id=${selectedEmployeeId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (!response.ok) throw new Error("Logout failed");
      fetchEmployees();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredEmployees = employees.filter(
    (employee) =>
      employee.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      employee.clg_email?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div>
      <HRNavbar />

      <Box
        sx={{
          flexGrow: 1,
          ml: 1,
          mr: 1,
          mt: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              marginTop: "20px",
              marginLeft: "10px",
            }}
            color="text.secondary"
            gutterBottom
          >
            Employee Logout
          </Typography>
          <Box
            component="form"
            sx={{
              marginLeft: "2rem",
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "300px",
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Employee |"
              inputProps={{ "aria-label": "search employee" }}
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPage(0);
              }}
            />
            <IconButton type="button" sx={{ p: "10px" }}>
              <SearchIcon style={{ color: "#A5D6A7" }} />
            </IconButton>
          </Box>
        </Stack>

        {/* 👇 TABLE HEIGHT KO 250px KAR DIYA HAI 👇 */}
        <TableContainer
          sx={{
            maxHeight: "311px",
            overflowY: "auto",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <EmployeeCard
                  style={{
                    display: "flex",
                    background: "#A5D6A7",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                    height: "3rem",
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    marginRight: 0,
                  }}
                >
                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 4, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">User Name</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Email ID</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Phone Number</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Gender</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Extension</Typography>
                  </CardContent>
                  <CardContent style={{ flex: 1 }}>
                    <Typography variant="subtitle2">Logout</Typography>
                  </CardContent>
                </EmployeeCard>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredEmployees
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((employee, index) => (
                  <TableRow key={employee.id}>
                    <EmployeeCard
                      style={{
                        display: "flex",
                        height: "3.8rem",
                        background: "white",
                        color: "rgba(0, 0, 0, 0.87)",
                        borderRadius: "8px 10px 8px 8px",
                        alignItems: "center",
                      }}
                    >
                      <CardContent style={{ flex: 1 }}>
                        <Typography variant="subtitle2">
                          {index + 1 + page * rowsPerPage}
                        </Typography>
                      </CardContent>

                      <CardContent
                        style={{
                          flex: 4,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Typography variant="subtitle2" noWrap>
                          {employee.name}
                        </Typography>
                      </CardContent>

                      <CardContent
                        style={{
                          flex: 3,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Typography variant="subtitle2" noWrap>
                          {employee.clg_email}
                        </Typography>
                      </CardContent>

                      <CardContent style={{ flex: 2 }}>
                        <Typography variant="subtitle2">
                          {employee.clg_mobile_no}
                        </Typography>
                      </CardContent>

                      <CardContent style={{ flex: 2 }}>
                        <Typography variant="subtitle2">
                          {employee.clg_gender == 1
                            ? "Female"
                            : employee.clg_gender == 2
                              ? "Male"
                              : "N/A"}
                        </Typography>
                      </CardContent>

                      <CardContent style={{ flex: 2 }}>
                        <Typography variant="subtitle2">
                          {employee.extension_id}
                        </Typography>
                      </CardContent>

                      <CardContent
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <HighlightOffIcon
                          onClick={() => openLogoutDialog(employee.id)}
                          style={{ color: "red", cursor: "pointer" }}
                        />
                      </CardContent>
                    </EmployeeCard>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          sx={{ overflowY: "hidden", mt: 1 }}
          rowsPerPageOptions={[5, 10, 25, 30, 50]}
          component="div"
          count={filteredEmployees.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">{"Forceful Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to log out this user? This action will end
            their current session.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmLogout} color="error" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </div>
  );
};

export default LoginEmployees;
